// Navigation du livret par l'ancre de l'URL (#intro, #livret, #livret/wifi...).
// Le bouton « retour » du téléphone fonctionne naturellement, et l'adresse de la page ne change pas.
// Fichier volontairement minuscule : il est chargé avec la page, le livret lui-même est chargé à la demande.
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function useLivretRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  const hash = decodeURIComponent(location.hash.replace(/^#/, ""));
  const depth = location.state?.lvDepth || 0;

  const route = useMemo(() => {
    if (hash === "intro") return { view: "intro" };
    if (hash === "livret") return { view: "home" };
    if (hash.startsWith("livret/")) return { view: "chapter", chapterId: hash.slice("livret/".length) };
    return null;
  }, [hash]);

  const go = useCallback((target, replace = false) => {
    navigate({ hash: target }, { replace, state: { lvDepth: replace ? depth : depth + 1 } });
  }, [navigate, depth]);

  const close = useCallback(() => {
    if (depth > 0) navigate(-depth);
    else navigate({ hash: "" }, { replace: true, state: null });
  }, [navigate, depth]);

  const back = useCallback(() => {
    if (depth > 1) navigate(-1);
    else go("livret", true);
  }, [navigate, depth, go]);

  return {
    route,
    openIntro: useCallback(() => go("intro"), [go]),
    openBook: useCallback((chapterId) => go(chapterId ? `livret/${chapterId}` : "livret"), [go]),
    openChapter: useCallback((chapterId) => go(`livret/${chapterId}`), [go]),
    introToBook: useCallback(() => go("livret", true), [go]),
    back,
    close,
  };
}

// Marque l'introduction comme vue pour ce séjour et cet appareil
const introKey = (token) => `livret_intro_vue:${token || "admin"}`;

export function hasSeenIntro(token) {
  try { return localStorage.getItem(introKey(token)) === "1"; } catch { return true; }
}

export function markIntroSeen(token) {
  try { localStorage.setItem(introKey(token), "1"); } catch { /* stockage indisponible */ }
}
